import { ActivationType, IncentiveType } from "api/models";
import { PreviewProduct } from "shared/types";

export const previewVariants: Record<PreviewProduct, ActivationType | IncentiveType> = {
  [PreviewProduct.ACTIVATION_POPUP]: ActivationType.VOUCHER,
  [PreviewProduct.NEWSLETTER_FORMS]: IncentiveType.FOMO
};
